import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Checkbox } from '@verclam/ui-kit';

const ArchivedFilter: React.FC = () => {
	const currentFilters = useSignalValue(subjectFiltersSignal);

	const handleIncludeArchivedChange = React.useCallback((includeArchived: boolean) => {
		setSubjectFilters(subjectFiltersSignal.peek().setIncludeArchived(includeArchived));
	}, []);

	return (
		<Checkbox
			name="subjectIncludeArchived"
			label="Inclure les archivés"
			checked={currentFilters.includeArchived}
			onChange={handleIncludeArchivedChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ArchivedFilter;
